/** @format */

import React, { Suspense, lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import Layout from 'src/ui/layout';
import { DocumentsContainer } from './containers';
import { updateBodyClass } from 'src/helpers';
import { DOCUMENTS_URL, BODY_CLASSES, CASES_URL } from 'src/constants/constants.js';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';

const CasesLandingContainer = lazy(() => import('src/ui/features/Cases/containers/CasesLandingContainer'));

class DocumentsRoot extends React.Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.CASES);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.CASES);
  }
  render() {
    return (
      <Layout headerName={'Case Management'}>
        <Suspense fallback={<ServiceSpinner open={true} />}>
          <Switch>
            <Route path={DOCUMENTS_URL} render={props => <DocumentsContainer {...props} />} />
            <Route path={CASES_URL + '/team'} render={props => <CasesLandingContainer key={'teamCases'} teamCases={true} {...props} />} />
            <Route path={CASES_URL} render={props => <CasesLandingContainer key={'cases'} {...props} />} />
          </Switch>
        </Suspense>
      </Layout>
    );
  }
}

export default DocumentsRoot;
